import apiClient from "@/apiClient";

class ProductService {
  async index() {
    try {
      const response = await apiClient.get("/api/product");
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async pricingIndex() {
    try {
      const response = await apiClient.get("/api/pricing/products");
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async pricingDateRanges() {
    const response = await apiClient.get("/api/pricing/date-ranges");
    return response.data;
  }

  async createPricingDateRange(payload) {
    const response = await apiClient.post("/api/pricing/date-ranges", payload);
    return response.data;
  }

  async updatePricingDateRange(dateRangeId, payload) {
    const response = await apiClient.put(
      `/api/pricing/date-ranges/${dateRangeId}`,
      payload,
    );
    return response.data;
  }

  async managementIndex() {
    const response = await apiClient.get("/api/unit-management");
    return response.data;
  }

  async vehicleTypes() {
    const response = await apiClient.get("/api/vehicle-types");
    return response.data;
  }

  async create(payload) {
    const response = await apiClient.post("/api/product", payload);
    return response.data;
  }

  async update(productId, payload) {
    const response = await apiClient.put(`/api/product/${productId}`, payload);
    return response.data;
  }

  async delete(productId) {
    await apiClient.delete(`/api/product/${productId}`);
  }

  async createVehicleType(payload) {
    const response = await apiClient.post("/api/vehicle-types", payload);
    return response.data;
  }

  async updateVehicleType(vehicleTypeId, payload) {
    const response = await apiClient.put(
      `/api/vehicle-types/${vehicleTypeId}`,
      payload,
    );
    return response.data;
  }

  async createPersonnelType(payload) {
    const response = await apiClient.post("/api/staff-skills", payload);
    return response.data;
  }

  async updatePersonnelType(personnelTypeId, payload) {
    const response = await apiClient.put(
      `/api/staff-skills/${personnelTypeId}`,
      payload,
    );
    return response.data;
  }

  async createPricePeriod(productId, payload) {
    const response = await apiClient.post(
      `/api/pricing/products/${productId}/periods`,
      payload,
    );
    return response.data;
  }

  async updatePricePeriod(periodId, payload) {
    const response = await apiClient.put(
      `/api/pricing/periods/${periodId}`,
      payload,
    );
    return response.data;
  }

  async deletePricePeriod(periodId) {
    const response = await apiClient.delete(`/api/pricing/periods/${periodId}`);
    return response.data;
  }

  async createRequirementPayPeriod(requirementId, payload) {
    const response = await apiClient.post(
      `/api/pricing/requirements/${requirementId}/periods`,
      payload,
    );
    return response.data;
  }

  async logisticsPricing() {
    const response = await apiClient.get("/api/pricing/logistics");
    return response.data;
  }

  async updateLogisticsPricing(payload) {
    const response = await apiClient.put("/api/pricing/logistics", payload);
    return response.data;
  }

  async updateVehicleRequirement(productId, payload) {
    const response = await apiClient.put(
      `/api/pricing/products/${productId}/vehicle-requirement`,
      payload,
    );
    return response.data;
  }

  async updateProductPricePeriods(productId, payload) {
    const response = await apiClient.put(
      `/api/pricing/products/${productId}/periods`,
      payload,
    );
    return response.data;
  }

  async updateRequirementPayPeriod(periodId, payload) {
    const response = await apiClient.put(
      `/api/pricing/requirements/periods/${periodId}`,
      payload,
    );
    return response.data;
  }

  async deleteRequirementPayPeriod(periodId) {
    const response = await apiClient.delete(
      `/api/pricing/requirements/periods/${periodId}`,
    );
    return response.data;
  }
}
export default ProductService;
